import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VentaService } from '../../../services/venta.service';
import { Observable } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { Producto } from '../../../interfaces/producto.interface';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.css']
})
export class ProductosComponent implements OnInit {

  categoria = '';
  productos: Observable<any>;

  productoForm = this.fb.group({
    barcode: [''],
    category: [''],
    cost: [''],
    id: [''],
    margin: [''],
    name: [''],
    neto: [''],
    precio: [''],
    stock: [''],
    kilo: ['', Validators.required],
    cantidad: ['', [Validators.required, Validators.min(1)]],

  });

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private ar: ActivatedRoute,
    public service: VentaService
  ) { }

  ngOnInit(): void {
    this.ar.params.subscribe(
      (params) => {
        this.categoria = params.categoria;
        this.obtenerProductos();
      }
    );
  }

  obtenerProductos() {
    this.productos = this.service.obtenerProductosCategoria(this.categoria);
  }

  cuadroProducto(producto: Producto) {
    
    $('#modalProducto').modal({ keyboard: false });

    this.productoForm.controls.barcode.setValue(producto.barcode);
    this.productoForm.controls.category.setValue(producto.category);
    this.productoForm.controls.cost.setValue(producto.cost);
    this.productoForm.controls.id.setValue(producto.id);
    this.productoForm.controls.margin.setValue(producto.margin);
    this.productoForm.controls.name.setValue(producto.name);
    this.productoForm.controls.neto.setValue(producto.neto);
    this.productoForm.controls.precio.setValue(producto.precio);
    this.productoForm.controls.stock.setValue(producto.stock);
    this.productoForm.controls.kilo.setValue(producto.kilo);
    this.productoForm.controls.cantidad.setValue(producto.cantidad);
  }

  agregarDigito(numero: string) {
    let cantidad: string = this.productoForm.controls.cantidad.value;
    if (!cantidad) {
      cantidad = numero
    } else {
      cantidad = cantidad + numero;
    }
    this.productoForm.controls.cantidad.setValue(Number.parseInt(cantidad, 10));
  }

  borrarDigito() {
    let cantidad: string = this.productoForm.controls.cantidad.value.toString();
    if (!cantidad) {
      return;
    }

    if (cantidad.length === 1) {
      this.productoForm.controls.cantidad.setValue('');
      return;
    }

    const ultIndex = cantidad.length - 1;
    cantidad = cantidad.substring(0, ultIndex);

    this.productoForm.controls.cantidad.setValue(cantidad);
  }

  agregarProducto() {
    if (this.productoForm.invalid) {
      return;
    }

    const producto: Producto = this.productoForm.value;
    producto.name = producto.name.replace(/[üéáíóúñÑÜÁÉÍÓÚ]+/g, 'x');
    if (producto.kilo > 10) {
      const cantidad: number = Math.round(((producto.cantidad / producto.kilo) + Number.EPSILON) * 100) / 100;

      producto.precio = producto.cantidad;
      producto.cantidad = cantidad;
    }

    this.service.agregarProductoLista(producto, producto.cantidad);
    this.service.calcularTotal();
    this.cerrarModal();
  }

  cerrarModal() {
    this.productoForm.reset();
    $('#modalProducto').modal('hide');
  }

}
